<template>
    <div class="content-wrapper">

        <form :data-url='updatedUrl'
              method="POST"
              ref="form"
              enctype="multipart/form-data">

            <div v-if="fieldStatus.isSubmit && errors && Object.keys(errors).length > 0" class="alert alert-danger">
                <!-- Display validation errors -->
                <span v-for="(errorMessages, field) in errors" :key="field">
                        <div v-for="(error, index) in errorMessages" :key="index">
                            {{ error }}<br>
                        </div>
                </span>
            </div>

            <!-- Loop through questions -->
            <div v-if="lesson?.questions && lesson.questions.length"
                 v-for="(question, questionIndex) in lesson.questions"
                 :key="question.id">
                <div class="question">
                    <p><strong>{{ questionIndex + 1 }}. {{ question.question_text }}</strong></p>

                    <!-- Loop through answers for each question -->
                    <div v-if="question?.answers && question.answers.length" class="answers-container">
                        <div class="answers-left">
                            <app-form-group
                                v-for="(answer, answerIndex) in question.answers.slice(0, 2)" :key="answer.id"
                                :label="''"
                                type="radio"
                                :radio-checkbox-name="'answers[' + question.id + ']'"
                                :list="[{'id': answer.id, 'value': answer.answer_text}]"
                                v-model="answers[question.id]"
                            />
                        </div>

                        <div class="answers-right">
                            <app-form-group
                                v-for="(answer, answerIndex) in question.answers.slice(2, 4)" :key="answer.id"
                                :label="''"
                                type="radio"
                                :radio-checkbox-name="'answers[' + question.id + ']'"
                                :list="[{'id': answer.id, 'value': answer.answer_text}]"
                                v-model="answers[question.id]"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- Submit and Close buttons -->
            <div class="form-actions mt-2">
                <!--                <button type="button" class="btn btn-danger" @click="closeModal">Close</button>-->
                <button type="button" class="btn btn-primary" @click="submit">Submit</button>
            </div>

        </form>

    </div>
</template>

<script>
import ModalMixin from "../../../../../../common/Mixin/Global/ModalMixin";
import {calenderTimeWithMonthSortName} from "../../../../../../common/Helper/Support/DateTimeHelper";
import {axiosPost, urlGenerator} from "../../../../../../common/Helper/AxiosHelper";
import {FormMixin} from "../../../../../../core/mixins/form/FormMixin";


export default {
    name: "LessonQuestion",
    mixins: [ModalMixin, FormMixin],
    props: ['props', 'value'],
    data() {
        return {
            urlGenerator,
            calenderTimeWithMonthSortName,
            preloader: false,
            loading: false,
            message: '',
            errors: {},
            lesson: '',
            fieldStatus: {isSubmit: false},
            tableId: {},
            updatedUrl: '',
            answers: {
                type: Object,
                default: () => ({}),
            },
        }
    },
    created() {
        this.lesson = this.props.lesson;
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = new FormData();
            // Ensure that only integers are appended to formData
            Object.keys(this.answers).forEach(key => {
                let answer = parseInt(this.answers[key], 10);  // Convert answer to an integer
                if (!isNaN(answer)) {
                    formData.append(`answers[${key}]`, answer);  // Append the valid integer answer
                } else {
                    console.warn(`Invalid answer for question ${key}: ${this.answers[key]}`);
                }
            });
            const url = `${this.apiUrl.COURSE}/${this.lesson.course_id}/lessons/${this.lesson.id}/submit`;

            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#course-lesson-detail-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;

                // Show success message first
                this.$toastr.s(data.message);

                if (data.download_url) {
                    // Create hidden iframe for download
                    const iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    iframe.src = data.download_url;
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                    iframe.onload = () => {
                        setTimeout(() => {
                            document.body.removeChild(iframe);
                        }, 1000);
                    };
                    document.body.appendChild(iframe);
                }

                this.toastAndReload('', 'course-lesson-table');
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                if (response) {
                    this.afterError(response)
                    this.fieldStatus.isSubmit = true;
                    if (response.status !== 422) {
                        this.$toastr.e(response.data.message || response.statusText);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                }
            });
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#course-lesson-detail-modal').modal('hide');
            this.toastAndReload(data.message, 'course-lesson-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        }
    },
}
</script>
<style scoped>
.answers-container {
    display: flex;
    justify-content: space-between;
}

.answers-left,
.answers-right {
    width: 48%;  /* Adjust the width as needed */
}

.answers-left {
    padding-right: 10px;  /* Add space between the two columns */
}

.answers-right {
    padding-left: 10px;  /* Add space between the two columns */
}
</style>
